import {
  BeefIcon,
  CoffeeIcon,
  CookieIcon,
  CupSodaIcon,
  DrumstickIcon,
  FishIcon,
  HamburgerIcon,
  type LucideIcon,
  PizzaIcon,
  SaladIcon,
  SandwichIcon,
  SoupIcon,
  UtensilsIcon,
} from "lucide-react"

/**
 * Best-effort icon for a menu category. Fixture/backend categories carry no
 * `icon` field (see MenuCategory in @workspace/model), so the homepage tiles and
 * the header category chips derive a friendly glyph from the category name/id by
 * keyword — falling back to a neutral plate. Presentation only; never used for
 * anything the diner must be able to read (a11y copy is always the text name).
 */
const KEYWORD_ICON: ReadonlyArray<readonly [RegExp, LucideIcon]> = [
  [/pizza/i, PizzaIcon],
  [/burger/i, HamburgerIcon],
  [/chicken|wing|nugget/i, DrumstickIcon],
  [/side|fries|chip/i, UtensilsIcon],
  [/salad|veg|green/i, SaladIcon],
  [/dessert|sweet|cake|ice/i, CookieIcon],
  [/drink|beverage|soda|juice/i, CupSodaIcon],
  [/deal|combo|meal|bundle/i, UtensilsIcon],
  [/sushi|roll|japan/i, FishIcon],
  [/pasta|noodle|italian/i, SoupIcon],
  [/kebab|grill|bbq/i, BeefIcon],
  [/sandwich|wrap|sub/i, SandwichIcon],
  [/breakfast|brunch/i, SandwichIcon],
  [/coffee|tea|hot/i, CoffeeIcon],
  [/curry|indian|spice/i, SoupIcon],
]

const FALLBACK_ICON: LucideIcon = UtensilsIcon

export function categoryIcon(category: {
  id: string
  name: string
  icon?: string
}): LucideIcon {
  const haystack = `${category.name} ${category.id}`
  for (const [pattern, icon] of KEYWORD_ICON) {
    if (pattern.test(haystack)) return icon
  }
  return FALLBACK_ICON
}
